import { Caption, Spacing, Text } from '@vkontakte/vkui';
import image from 'img/crossPromoVkMusicFakedoor/vkMusic30.png';
import imageDark from 'img/crossPromoVkMusicFakedoor/vkMusic30Dark.png';
import React, { memo, useCallback, useEffect } from 'react';
import { crossPromoVkMusicFakedoor } from 'reactApp/appHelpers/featuresHelpers/features/crossPromoVkMusicFakedoor';
import { WhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { crossPromoVkMusicFakedoorModalAnalyticsMap } from 'reactApp/ui/CrossPromoVkMusicFakedoorModal/CrossPromoVkMusicFakedoorModal.analytics';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { isDarkThemeModeEnabled } from 'reactApp/utils/theme';

import styles from './CrossPromoVkMusicFakedoorModalThanks.css';

export interface Props {
    onClose: () => void;
}

export const CrossPromoVkMusicFakedoorModalThanks = memo<Props>(({ onClose }) => {
    const sendAnalytics = useCallback((action) => {
        sendPaymentGa({
            action,
            eventCategory: ECategoryGa.modal,
            name: `${crossPromoVkMusicFakedoorModalAnalyticsMap[crossPromoVkMusicFakedoor]}_thanks`,
        });
    }, []);

    useEffect(() => {
        sendAnalytics('show');
    }, []);

    const handleClick = useCallback(() => {
        sendAnalytics('click');
        onClose();
    }, [onClose, sendAnalytics]);
    const handleClose = useCallback(() => {
        sendAnalytics('close');
        onClose();
    }, [onClose, sendAnalytics]);

    if (!crossPromoVkMusicFakedoor) {
        return null;
    }

    const containsDarkTheme = isDarkThemeModeEnabled();

    const content = (
        <>
            <Spacing size={16} />
            <Text className={styles.text} weight="3">
                {
                    'У нас это пока в разработке, а пока можете забрать подарок. Промокод на\u00A030\u00A0дней подписки на\u00A0VK\u00A0Музыку придёт вам на\u00A0Почту'
                }
            </Text>
            <Spacing size={32} />
        </>
    );

    const footerText = (
        <>
            <Caption className={styles.caption}>
                {
                    'Предложение доступно для пользователей, у которых ранее не\u00A0было какой-либо музыкальной подписки ВКонтакте.\nЛицензионное соглашение: '
                }
                <a className={styles.link} target="_blank" href={'https://vk.ru/legal/music_license'} rel="noreferrer">
                    vk.ru/legal/music_license
                </a>
            </Caption>
        </>
    );

    return (
        <WhatsNewDialog
            primaryButtonText="Буду ждать"
            title="Пока работаем над этим"
            imageUrl={containsDarkTheme ? imageDark : image}
            content={content}
            dialogSize="large"
            buttonTheme="vk"
            onClick={handleClick}
            onClose={handleClose}
            footerText={footerText}
            footerTextRightToButtons
            closeIconClassName={containsDarkTheme ? styles.closeIconDark : undefined}
        />
    );
});

CrossPromoVkMusicFakedoorModalThanks.displayName = 'CrossPromoVkMusicFakedoorModalThanks';
